import { Button, DesktopModal, Flex, IconFont, Loading, Text } from '@byecode/ui'
import { useStore } from '@xyflow/react'
import { memo } from 'react'
import styled from 'styled-components'

import { useFlowContainerContext } from '@/contexts/FlowContext'

import { RUNNING_STATUS_COLOR_MAP, RUNNING_STATUS_ICON_MAP, RUNNING_STATUS_MAP, RUNNING_STATUS_TINY_COLOR_MAP } from '../../constants'

const SCResultBox = styled.div<{ color: string; tinyColor: string }>`
    display: flex;
    margin: 16px;
    padding: 14px 8px;
    border-radius: 8px;
    border-width: 2px;
    border-style: solid;
    border-color: ${({ color }) => color};
    background: ${({ tinyColor }) => tinyColor};
    box-shadow: 0px 1px 2px 0px #1018280f;
    & > * {
        flex: 1;
    }
`

const FlowRunning = memo(() => {
    const running = false
    const { log } = useFlowContainerContext()
    if (running) {
        return (
            <Flex direction="column" alignItems="center" justifyContent="space-between" styles={{ root: { height: '100%', padding: 16 } }}>
                <Loading size={48} shape="indicator" description="测试运行中" showProgress={false} />
                <Button block size="lg" icon={<IconFont type="AbortCircle" size={16} />}>
                    停止
                </Button>
            </Flex>
        )
    }

    return (
        <SCResultBox color={RUNNING_STATUS_COLOR_MAP[log?.state || 'all']} tinyColor={RUNNING_STATUS_TINY_COLOR_MAP[log?.state || 'all']}>
            <Flex gap={4} direction="column" alignItems="center">
                <Text size={12} color="var(--color-gray-500)" lineHeight="20px">
                    状态
                </Text>
                <Flex gap={4}>
                    <IconFont
                        type={RUNNING_STATUS_ICON_MAP[log?.state || 'all']}
                        size={20}
                        fill={log?.state && RUNNING_STATUS_COLOR_MAP[log?.state]}
                    />
                    <Text size={14} lineHeight="22px" color={log?.state && RUNNING_STATUS_COLOR_MAP[log?.state]}>
                        {log?.state && RUNNING_STATUS_MAP[log?.state]}
                    </Text>
                </Flex>
            </Flex>
        </SCResultBox>
    )
})

export const FlowRunningModal = () => {
    const rootEl = useStore(s => s.domNode)
    const { setModalState } = useFlowContainerContext()
    return (
        <DesktopModal
            open
            onClose={() => setModalState({})}
            title="测试结果"
            withOverlay={false}
            closeOnClickOverlay={false}
            trapFocus={false}
            width={360}
            target={rootEl}
            styles={{
                root: { pointerEvents: 'none' },
                modal: {
                    pointerEvents: 'initial',
                    position: 'absolute',
                    top: 60,
                    right: 12,
                    bottom: 12
                },
                body: {
                    padding: '0 !important'
                }
            }}
            transition={{ from: { x: '100%' }, to: { x: '0%' } }}
        >
            <FlowRunning />
        </DesktopModal>
    )
}
